<template>
  <v-form class="my-2"
      v-model="detailMixin.valid"
      ref="formBeschrijvingPand">
      <div
      v-if="detailMixin.element && detailMixin.element.multicheck && detailMixin.element.fields"
      :class="DetailMixin_Dirty ? 'dirtyForm' : DetailMixin_Revertable && !detailMixin.element.isNew ? 'editForm' : ''"
      >
      <h2 class="primary--text">Nadere beschrijving van het pand</h2>

      <div v-if="selectieControlTypes && selectieControlTypes.length">
        <control-multi-check :cols="3" :list="kamerTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[0].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[0].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="kamerTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[1].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[1].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="kamerTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[2].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[2].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="kamerTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[3].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[3].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="kamerTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[4].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[4].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="kamerTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[5].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[5].langeBeschrijving"/>
        <v-divider></v-divider>
        <control-multi-check :cols="3" :list="bijgebouwTypes" v-model="detailMixin.element.multicheck[selectieControlTypes[6].idCode]" :selectieControlTypes="selectieControlTypes" :title="selectieControlTypes[6].langeBeschrijving"/>
      </div>
      <v-divider class="mb-5"></v-divider>

      <h3 class="secondary--text my-3">Extra</h3>
      <v-row class="pb-0">
        <v-col cols="12" md="6">
          <v-textarea label="Beschrijving" auto-grow outlined v-model="detailMixin.element.fields.extraBeschrijving" single-line/>
        </v-col>
      </v-row>

      <v-divider class="my-5"></v-divider>

      <h3 class="secondary--text my-3">Bijlage</h3>
      <v-row class="pb-0">
        <v-col cols="12" md="6">
          <control-file-input-drag-and-drop v-model="detailMixin.element.files" @download="Download($event)" :accept="['.png', '.jpg', '.jpeg', '.gif']"/>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import ControlFileInputDragAndDrop from '../ControlFileInputDragAndDrop.vue'
import ControlMultiCheck from '../ControlMultiCheck.vue'
import codeService from '../../services/codeService'
import errorMixin from '@/mixins/errorMixin'
import commonMixin from '@/mixins/commonMixin'
import detailMixin from '../../mixins/detailMixin'
import schattingService from '../../services/schattingService'
import blobMixin from '../../mixins/blobMixin'
import offlineStorage from '@/utils/offlineStorage'
import networkStatus from '@/utils/networkStatus'
import { debounce } from 'lodash'

export default {
  components: {
    ControlFileInputDragAndDrop,
    ControlMultiCheck
  },
  mixins: [
    errorMixin,
    commonMixin,
    detailMixin,
    blobMixin
  ],
  mounted () {
    codeService.Init(this)
    this.initAutoSave()
  },
  props: {
    idSchatting: {
      default: null,
      type: String
    },
    visible: Boolean
  },
  data () {
    return {
      referentieType: 'e7409aeb-0b8a-4d3b-adef-686b46c86160',
      kamerTypes: null,
      bijgebouwTypes: null,
      selectieControlTypes: null,
      extraBeschrijving: null
    }
  },
  watch: {
    async visible () {
      if (this.visible) {
        await this.SetVariables()
        await this.loadEverything()
        await this.SetSelectionList()
      } else if (this.DetailMixin_Dirty) {
        this.DetailMixin_Save()
      }
    },
    // Deep watch for automatic caching of afmetingen data
    'detailMixin.element.multicheck': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    },
    'detailMixin.element.fields': {
      deep: true,
      handler: function (newVal, oldVal) {
        // Only auto-save if we have data and it's not the initial load
        if (newVal && oldVal && this.idSchatting) {
          this.debouncedAutoSave()
        }
      }
    }
  },
  methods: {
    initAutoSave () {
      // Create a debounced version of the auto-save function
      // This will wait 1 second after the last change before saving
      this.debouncedAutoSave = debounce(this.autoSaveToCache, 1000)
    },
    async autoSaveToCache () {
      const id = this.DetailMixin_GetId()
      if (!id || !this.detailMixin.element?.fields || !this.detailMixin.element?.multicheck) return

      try {
        await offlineStorage.saveSchattingStep('beschrijvingPand', id, this.detailMixin.element.fields)
        await offlineStorage.saveSchattingStep('beschrijvingPandCodeSelecties', id, this.detailMixin.element.multicheck)
        this.CommonMixin_Snackbar('Aanpassing lokaal opgeslagen', 'success')
      } catch (error) {
        console.error('Auto-save to cache failed:', error)
        this.CommonMixin_Snackbar('Automatisch opslaan mislukt', 'error')

        // Clear the error message after 3 seconds
        setTimeout(() => {
          if (this.autoSaveStatus === 'error') {
            this.autoSaveStatus = null
            this.autoSaveMessage = ''
          }
        }, 3000)
      }
    },
    Download (blob) {
      const blobFormatted = this.CommonMixin_Clone(blob)
      blobFormatted.bestandsnaam = blob.name
      this.BlobMixin_Download(blobFormatted)
    },
    async loadEverything () {
      this.CommonMixin_Load(this.$options.name, true)
      await this.SetKamerTypes()
      await this.SetBijgebouwTypes()
      await this.SetSelectieControlTypes()
      this.CommonMixin_Load(this.$options.name, false)
    },
    async SetKamerTypes () {
      var cachedKamerTypes = await offlineStorage.getLookupData('kamerTypes')
      this.kamerTypes = cachedKamerTypes
    },
    async SetBijgebouwTypes () {
      var cachedBijgebouwTypes = await offlineStorage.getLookupData('bijgebouwTypes')
      this.bijgebouwTypes = cachedBijgebouwTypes
    },
    async SetSelectionList () {
      const id = this.DetailMixin_GetId()

      if (id) {
        const responseBeschrijvingPandMulticheck = await offlineStorage.getSchattingStep('beschrijvingPandCodeSelecties', id)
        const element = {
          multicheck: {},
          fields: {},
          files: []
        }

        if (responseBeschrijvingPandMulticheck) {
          // Filter out offlineStorage metadata fields
          const { idSchatting, timestamp, syncStatus, ...multicheckData } = responseBeschrijvingPandMulticheck
          element.multicheck = this.CommonMixin_Clone(multicheckData)
          this.$forceUpdate()
        }

        const responseBeschrijvingPand = await offlineStorage.getSchattingStep('beschrijvingPand', id)
        if (responseBeschrijvingPand) {
          element.fields = this.CommonMixin_Clone(responseBeschrijvingPand)
          this.$forceUpdate()
        }

        this.detailMixin.element = this.CommonMixin_Clone(element)

        if (networkStatus.isOnline()) {
          try {
            const files = await this.BlobMixin_GetFiles(this.idSchatting, this.referentieType)
            this.detailMixin.element.files = files
            this.$forceUpdate()
          } catch (error) {
            console.warn('Kon blobs niet ophalen:', error)
            if (!responseBeschrijvingPand) {
              console.error('Geen cached data beschikbaar voor afmetingen')
            }
          }
        }

        this.DetailMixin_InitDirtyWatch()
      }
    },
    async SetSelectieControlTypes () {
      const cachedSelectieControlTypes = await offlineStorage.getLookupData('selectieControlTypes')
      if (cachedSelectieControlTypes) {
        this.selectieControlTypes = cachedSelectieControlTypes.filter(x => x.waarde >= 300 && x.waarde <= 399)
      }
    },
    SetVariables () {
      this.detailMixin.key = 'id'
      this.detailMixin.rightsNeeded = ['admin', 'gebruiker']
      this.detailMixin.functions.validate = this.$refs.formBeschrijvingPand.validate
      this.detailMixin.functions.save = this.save
    },
    async save (element) {
      var multicheck = await codeService.SaveMulticheck({ IdReferentie: this.idSchatting, IdCodeReferentieType: this.referentieType, MultiSelects: element.multicheck })
      var fields = await schattingService.UpdateSchattingBeschrijvingPand(element.fields)
      await this.BlobMixin_SaveFiles(element.files, this.idSchatting, this.referentieType)
      var multicheckData = null
      var fieldsData = null
      if (multicheck && multicheck.data) {
        multicheckData = multicheck.data
      }
      if (fields && fields.data) {
        fieldsData = fields.data
      }
      return {
        data: {
          multicheck: multicheckData,
          fields: fieldsData
        }
      }
    },
    Validate () {
      this.$refs.formBeschrijvingPand.validate()
      return this.detailMixin.valid
    }
  }
}
</script>
